<script setup>

const props = defineProps({
    usuarioStore: Object
})

const usuarioStore = props.usuarioStore;
const emit = defineEmits(["toggle-register"]);

function isRegister() {
    emit("toggle-register");
}

const registrarUsuario = async () => {
    await usuarioStore.registrarUsuario();
};

</script>

<template>
    <div class="w-100" style="max-width: 400px;">
        <h2 class="fw-bold">Bienvenido</h2>
        <p>Regístrate en la nueva plataforma.</p>
        <p>¿Ya tenés una cuenta? <a @click="isRegister()" class="text-primary fw-bold">Ingresá</a></p>

        <form @submit.prevent="registrarUsuario()">
            <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="email" class="form-control" v-model="usuarioStore.user.email" id="email" required>
            </div>

            <div class="mb-3">
                <label for="password" class="form-label">Contraseña</label>
                <input type="password" class="form-control" id="password" v-model="usuarioStore.user.password" required>
            </div>

            <div class="mb-3">
                <label for="repeat-password" class="form-label">Repetir contraseña</label>
                <input type="password" class="form-control" id="repeat-password" v-model="usuarioStore.user.passwordrepit" required>
            </div>

            <div class="mb-3">
                <label for="source" class="form-label">¿Cómo te enteraste de Adrián Mercado?*</label>
                <select class="form-select" id="source">
                    <option selected>Seleccionar</option>
                    <option value="1">Publicidad</option>
                    <option value="2">Recomendación</option>
                    <option value="3">Redes sociales</option>
                    <option value="4">Otro</option>
                </select>
            </div>

            <div class="form-check mb-2">
                <input type="checkbox" class="form-check-input" id="terms" required>
                <label class="form-check-label" for="terms">
                    He leído y acepto los <a href="#" class="fw-bold text-decoration-none">Términos y Condiciones del Sitio</a>
                </label>
            </div>

            <div class="form-check mb-4">
                <input type="checkbox" class="form-check-input" id="privacy" required>
                <label class="form-check-label" for="privacy">
                    He leído y acepto la <a href="#" class="fw-bold text-decoration-none">Declaración de Privacidad y Confidencialidad de la Información</a>
                </label>
            </div>

            <button type="submit" class="btn btn-primary w-40 fw-bold">Registrarme</button>
        </form>
    </div>
</template>